import { useEffect, useState } from "react";
import { useSegmentAnalyticsStore } from "../store";
export const useAnonymousId = () => {
    const client = useSegmentAnalyticsStore((state) => state.client);
    const [anonymousId, setAnonymousId] = useState(undefined);
    useEffect(() => {
        if (!client)
            return;
        const unSub = client.userInfo.onChange((value) => setAnonymousId(value.anonymousId));
        setAnonymousId(client.userInfo.get().anonymousId);
        return unSub;
    }, [client]);
    return anonymousId;
};
//# sourceMappingURL=useAnonymousId.js.map